import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { Close, Delete, PersonSearch } from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
  styled,
} from '@mui/material';
import UserStore from '../../store/UserStore';
import AuthStore from '../../store/AuthStore';
import LeadStore from '../../store/LeadStore';
import { SelectCreatePipeline } from '../SelectCreateWorkflowStatus';
import { WorkflowStatusRowRepeater } from '../WorkflowStatusRowRepeater';
import { CustomStyledButton, CustomStyledDialog } from '../../utils/helper';
import { SelectPipeline } from '../NewLeadDrawer/SelectPipeline';
import { toJS } from 'mobx';
import LoadingProgressStore from '../../store/LoadingProgressStore';

export const NewPipelineDialog = observer(({ toggleDialog, handleDialog, isNew }) => {
  const emptyFormData = {
    name: '',
    description: '',
    createdDate: new Date(),
    createdBy: AuthStore.userDetails.Name,
    updatedDate: new Date(),
    updatedBy: AuthStore.userDetails.Name,
  };

  const [formData, setFormData] = useState(emptyFormData);
  const [workFlowStatusRows, setWorkFlowStatusRows] = useState([]);
  const [isWorkflowStatusError, setIsWorkflowStatusError] = useState(false);
  const [toggleSubStatusValidation, setToggleSubStatusValidation] = useState(false);

  const [showError, setShowError] = useState(false);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [defaultRows, setDefaultRows] = useState(null);

  useEffect(() => {
    if (toggleDialog) {
      LeadStore.getWorkflowStatus();
      LeadStore.getWorkflowSubStatus();
    }
    setFormData(emptyFormData);
  }, [toggleDialog]);

  useEffect(() => {
    if (selectedPipeline) {
      LoadingProgressStore.toggleIsLoading(true);
      LeadStore.getWorkflowStatusByPipeLineId(selectedPipeline.id);
      setFormData({
        ...formData,
        'name': selectedPipeline.name,
        'description': selectedPipeline.description,
      });
    }
  }, [selectedPipeline]);

  useEffect(() => {
    if (selectedPipeline && LeadStore.workflowStatusByPipeLine) {
      setDefaultRows(toJS(LeadStore.workflowStatusByPipeLine));
      LoadingProgressStore.toggleIsLoading(false);
    }
  }, [LeadStore.workflowStatusByPipeLine]);

  const [errors, setErrors] = useState({
    name: false,
    description: false,
    userId: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    name: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Perform validation
    if (name === 'name') {
      setErrors({ ...errors, [name]: isPipelineNameError(value) });
    } else {
      setErrors({ ...errors, [name]: isEmpty(value) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedErrors = {
      name: isPipelineNameError(formData.name),
      description: isEmpty(formData.description),
    };
    setErrors(updatedErrors);
    let isWorkflowError = false;
    if (
      workFlowStatusRows.filter((item) => item.workflowStatus === null).length > 0 &&
      workFlowStatusRows.length === 1
    ) {
      isWorkflowError = true;
    } else if (
      workFlowStatusRows.length > 1 &&
      workFlowStatusRows.filter((item) => item.workflowStatus === null).length > 0
    ) {
      isWorkflowError = true;
    }
    setIsWorkflowStatusError(isWorkflowError);

    if (
      !Object.values(updatedErrors).some((error) => error === true) &&
      !isWorkflowError &&
      !checkWorkflowSubStatusError()
    ) {
      const workflowStatusConfiguration = [];
      debugger
      workFlowStatusRows.forEach((item) => {
        const workflowSubStatusRequestDto = [];
        item.workflowSubStatus?.forEach((subStatus) => {
          workflowSubStatusRequestDto.push({
            parentId: item.workflowStatus.id,
            id: subStatus.workflowSubStatus.id,
            name: subStatus.workflowSubStatus.name,
            sequence: subStatus.sequence,
          });
        });
        workflowStatusConfiguration.push({
          id: item.workflowStatus.id,
          name: item.workflowStatus.name,
          sequence: item.sequence,
          workflowSubStatusRequestDto,
        });
      });
      const payload = {
        ...formData,
        workflowStatusConfiguration: [...workflowStatusConfiguration],
      };

      debugger

      if (isNew) {
        LeadStore.createPipeline(payload);
      } else {
        payload.id = selectedPipeline.id;
        LeadStore.updatePipeLine(payload);
      }
    }
  };

  const checkWorkflowSubStatusError = () => {
    console.log(workFlowStatusRows);
    let subStatusErrorObjects = [];
    workFlowStatusRows.forEach((item) => {
      subStatusErrorObjects = [
        ...subStatusErrorObjects,
        ...item.workflowSubStatus.filter((subStatus) => subStatus.workflowSubStatus === null),
      ];
    });

    setToggleSubStatusValidation(Math.random());
    return subStatusErrorObjects.length > 0;
  };

  useEffect(() => {
    LeadStore.newPipelineSuccess && handleDialog();
  }, [LeadStore.newPipelineSuccess]);

  useEffect(() => {
    if (LeadStore.updatePipelineSuccess) {
      LeadStore.getWorkflowStatusByPipeLineId(selectedPipeline.id);
      handleDialog();
    }
  }, [LeadStore.updatePipelineSuccess]);

  const setRowDetails = (rows) => {
    setWorkFlowStatusRows(rows);
  };

  const isEmpty = (value) => {
    return value === null || value === undefined || (!Number.isInteger(value) && value?.trim() === '');
  };

  const isPipelineNameError = (value) => {
    if (isEmpty(value)) {
      setErrorMessages({ ...errors, 'name': '' });
      return true;
    } else if (
      isNew &&
      LeadStore.pipelines.find((item) => item.name?.trim().toLowerCase() === value?.trim().toLowerCase())
    ) {
      setErrorMessages({
        ...errors,
        'name': 'Pipeline already exist with the same name',
      });
      return true;
    } else {
      return false;
    }
  };

  const getPipelineDetailsFields = () => {
    return (
      <Stack direction={'column'} spacing={2} sx={{ py: '10px' }}>
        {isNew ? (
          ''
        ) : (
          <SelectPipeline
            pipelines={LeadStore.pipelines}
            showError={showError}
            handleSelectedPipeline={setSelectedPipeline}
          ></SelectPipeline>
        )}
        <TextField
          id="outlined-name"
          name="name"
          label="Name"
          size="small"
          value={formData.name}
          onChange={(e) => handleChange(e)}
          error={Boolean(errors.name)}
          helperText={Boolean(errors.name) && errorMessages.name}
          fullWidth
          className={isNew ? '' : 'lm-d-none'}
          required
        />
        <TextField
          id="outlined-description"
          name="description"
          label="Description"
          size="small"
          value={formData.description}
          onChange={handleChange}
          error={Boolean(errors.description)}
          fullWidth
          className={isNew ? '' : 'lm-d-none'}
          multiline
          rows={2}
          required
        />
      </Stack>
    );
  };

  const getDialogContent = () => {
    return isNew ? (
      <>
        <Divider sx={{ mb: '20px', mt: '20px' }}></Divider>
        <WorkflowStatusRowRepeater
          isError={isWorkflowStatusError}
          setRowDetails={setRowDetails}
          toggleSubStatusValidation={toggleSubStatusValidation}
          defaultRows={defaultRows}
        ></WorkflowStatusRowRepeater>
      </>
    ) : (
      getEditDialogContent()
    );
  };

  const getEditDialogContent = () => {
    return selectedPipeline && defaultRows ? (
      <>
        <Divider sx={{ mb: '20px', mt: '20px' }}></Divider>
        <WorkflowStatusRowRepeater
          isError={isWorkflowStatusError}
          setRowDetails={setRowDetails}
          toggleSubStatusValidation={toggleSubStatusValidation}
          defaultRows={defaultRows}
        ></WorkflowStatusRowRepeater>
      </>
    ) : (
      ''
    );
  };

  return (
    <CustomStyledDialog
      open={toggleDialog}
      onClose={(event, reason) => reason !== 'backdropClick' && handleDialog()}
      fullWidth={true}
      maxWidth={'lg'}
      noValidate
      PaperProps={{
        component: 'form',
        noValidate: true,
        onSubmit: (e) => handleSubmit(e),
      }}
    >
      <DialogTitle sx={{ fontWeight: '700' }}>{isNew ? 'New Pipeline' : 'Edit Pipeline'}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialog}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <DialogContent sx={{ minHeight: '18rem' }}>
        {getPipelineDetailsFields()}
        {getDialogContent()}
      </DialogContent>
      <DialogActions sx={{ p: '25px', pt: '0px', justifyContent: 'center' }}>
        <CustomStyledButton
          sx={{ width: '20% !important' }}
          variant="contained"
          color="success"
          type="submit"
          autoFocus
        >
          Save
        </CustomStyledButton>
      </DialogActions>
    </CustomStyledDialog>
  );
});
